<template>
  <div>

    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          พิจารณาแผนงาน
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
            v-for="(item, i) in tableHeader"
            :key="i"
            :style="{ 'width': item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <EvaluateListItem
            v-for="(item, i) in formAList"
            :key="i"
            :item="item"
            :index="i"
            :headers="tableHeader"
        ></EvaluateListItem>
      </div>
      <v-pagination
        class="mt-6"
        v-model="paginate.current_page"
        :length="paginate.last_page"
        color="#DE7033"
        @input="getFormAList"
    ></v-pagination>
    </div>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import Button from "../../components/input/Button"
import SelectBox from "../../components/input/SelectBox"
import EvaluateListItem from "../../components/EvaluateListItem"

export default {
  name: "EvaluateList",
  components: {
    TextField,
    SelectBox,
    EvaluateListItem,
    Button
  },
  data () {
    return {
      tableHeader: [
        {
          name: 'ลำดับ',
          width: '5%'
        },
        {
          name: 'ชื่อแผนงาน',
          width: '50%'
        },
        {
          name: 'ภูมิภาค',
          width: '20%'
        },
        {
          name: '',
          width: '20%'
        }
      ],
      formAList: [],
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
    }
  },
  created () {
    this.getFormAList()
  },
  methods: {
    async getFormAList (page) {
      let res
      let payload = {
        page: page,
      };
      console.log(payload)
      res = await this.$apiFire('BForm/getFormBList',payload);
      console.log(res)
      console.log(res.data)
      this.formAList = res.data.map((item, index) => {
        return {
          ...item,
          no: (res.current_page - 1) * res.per_page + index + 1
        }
      });
      this.paginate = {
        total: res.total,
        per_page: res.per_page,
        current_page: res.current_page,
        last_page: res.last_page,
      };
    },
  }
}
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>